<template lang="pug">
#other-office-room-schedule-list
  .box
    .box-header(v-if="_overBasicPlanByFamilyService && _useRoomSchedulesFunction")
      .d-flex.justify-content-start.align-items-center
        .note.d-flex.justify-content-start.flex-column
          span 連携済みの他事業所の空床情報を確認できます（確認可能なのは情報公開している事業所のみ）。
          span 空床情報公開には家族連絡サービスのベーシックプラン契約が必要です（他事業所の情報確認は契約プランに関係なく可能です）。
        .d-flex.justify-content-end.align-items-start.align-self-stretch.flex-fill
          button.btn.setting-btn.mr-2(@click="gotoSetting") 公開設定
          button.btn.schedule-btn(@click="gotoFamiliesRoomSchedule") 自施設の空床スケジュール
    .box-body
      b-tabs(v-model="tabIndex")
        //- 空床情報
        b-tab.tab(title="空床情報")
          RoomScheduleTab
        //- 仮申込み
        //- b-tab.tab(title="仮申込み")
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

import { userStore } from "@/store/store";
import { PcUrl } from "@/commons/constants/PcUrl";
import { PlanType } from "@/commons/services/Plans";

import RoomScheduleTab from "@/pc/containers/otherOfficeRoomSchedules/RoomScheduleTab.vue";

/**
 * ### 活動予定・履歴コンポーネント
 */
@Component({
  components: {
    RoomScheduleTab
  }
})
export default class RoomScheduleList extends Vue {
  /** タブインデックス(0始まり) */
  tabIndex: number = 0;

  get _useFamilyService(): boolean {
    return userStore.facility.useFamilyService;
  }

  /** ### プランがベーシック以上かを返す */
  get _overBasicPlanByFamilyService(): boolean {
    // 家族連絡サービス未契約の場合はベーシック以上ではない
    if (userStore.facility.useFamilyService != true) {
      return false;
    }
    // ベーシックプラン以上かを返す
    const planType: PlanType = userStore.facility.planType;
    if (PlanType.BASIC <= planType) {
      return true;
    } else {
      return false;
    }
  }

  /** ### 他事業所連携サービス、空床情報の使用可否を返す */
  get _useRoomSchedulesFunction(): boolean {
    return userStore.loginUser.permissions.functions.roomSchedulesFunction;
  }

  /** ### 空室／空床情報の設定画面へ遷移する */
  public gotoSetting(): void {
    this.$router.push({ name: PcUrl.RoomScheduleSetting, params: { type: "1" } });
    return;
  }

  /** ### 空室／空床情報の設定画面へ遷移する */
  public gotoFamiliesRoomSchedule(): void {
    this.$router.push(PcUrl.RoomScheduleList);
    return;
  }
}
</script>

<style lang="scss" scoped>
.setting-btn {
  min-width: 95px;
}
.schedule-btn {
  min-width: 240px;
}
</style>
